<script>
  import Spinner from "../components/ihm/ToolsSpinner.svelte";
  import { urlServeur } from "./conf.js";

  let brutRows = [];

  const fetchData = async () => {
    return fetch(urlServeur + "/api/immeubles/restau/")
    .then( response => response.json())
    .then(result => {
        brutRows = result.payload;
        //console.log(brutRows);
    })
    .catch(error => {
        console.log ('Err : Recup data HS : ',error)
    })
    }

     const  promise = fetchData();

</script>

<div class="container">
  {#await promise}
    <Spinner />
  {:then data}
    <table width="100%" class="table table-primary table-striped">
      <tr>
        <th>Nom</th>
        <th>type</th>
        <th>ville</th>
        <th>Tarif</th>
      </tr>
      <tbody>
        {#each brutRows as item}
          <tr>
            <td>{item.TW_TITRE}</td>
            <td>{item.TW_TYPE}</td>
            <td>{item.TW_VILLE}</td>
            <td>{parseFloat(item.TW_TARIF)}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/await}
</div>

<style>
  table {
    font-size: 0.75em;
  }
</style>
